import { Injectable } from "@angular/core";
import { BeneficiaryUsageIndicatorData } from "../../models/domains/pbm/indicators/beneficiary-usage-data";
import { CompanySubsidiaryBalanceIndicatorData } from "../../models/domains/pbm/indicators/company-subsidiary-balance-data";
import { MonthlyBalanceIndicatorData } from "../../models/domains/pbm/indicators/monthly-balance-data";
import { ProductSubtypeIndicatorData } from "../../models/domains/pbm/indicators/product-subtype-data";
import { TopTenNetworksIndicatorData } from "../../models/domains/pbm/indicators/top-ten-networks-data";
import { TopTenPractitionerIndicatorData } from "../../models/domains/pbm/indicators/top-ten-practitioner-data";
import { TopTenProductsIndicatorData } from "../../models/domains/pbm/indicators/top-ten-indicator-data";
import { IndicatorRepository } from "../../repositories/pbm/indicator.repository";

@Injectable({ providedIn: "root" })
export class IndicatorService {
  constructor(private indicatorRepository: IndicatorRepository) {}

  public async getIndicatorTypes() {
    return await this.indicatorRepository.getIndicatorTypes();
  }

  public async getBeneficiaryUsageData(fiscalNumber: Array<string> = null): Promise<BeneficiaryUsageIndicatorData> {
    const indicatorData = await this.indicatorRepository.getIndicatorDataByType("BeneficiaryUsage", fiscalNumber);
    return new BeneficiaryUsageIndicatorData(indicatorData);
  }

  public async getMonthlyBalance(fiscalNumber: Array<string> = null): Promise<MonthlyBalanceIndicatorData> {
    const indicatorData = await this.indicatorRepository.getIndicatorDataByType("MonthlyBalance", fiscalNumber);
    return new MonthlyBalanceIndicatorData(indicatorData);
  }

  public async getCompanySubsidiaryMonthlyBalance(fiscalNumber: Array<string>): Promise<CompanySubsidiaryBalanceIndicatorData> {
    const indicatorData = await this.indicatorRepository.getIndicatorDataByType("SubsidiaryMonthlyBalance", fiscalNumber);
    return new CompanySubsidiaryBalanceIndicatorData(indicatorData);
  }

  public async getTopTenProductsData(fiscalNumber: Array<string> = null): Promise<TopTenProductsIndicatorData> {
    const indicatorData = await this.indicatorRepository.getIndicatorDataByType("TopTenProducts", fiscalNumber);
    return new TopTenProductsIndicatorData(indicatorData);
  }

  public async getTopTenTherapeuticClass(fiscalNumber: Array<string> = null): Promise<TopTenProductsIndicatorData> {
    const indicatorData = await this.indicatorRepository.getIndicatorDataByType("TopTenTherapeuticClass", fiscalNumber);
    return new TopTenProductsIndicatorData(indicatorData);
  }

  public async getProductSubtypeData(fiscalNumber: Array<string> = null): Promise<ProductSubtypeIndicatorData> {
    const indicatorData = await this.indicatorRepository.getIndicatorDataByType("ProductSubType", fiscalNumber);
    return new ProductSubtypeIndicatorData(indicatorData);
  }

  public async getTopTenNetworksData(fiscalNumber: Array<string> = null): Promise<TopTenNetworksIndicatorData> {
    const indicatorData = await this.indicatorRepository.getIndicatorDataByType("TopTenNetworks", fiscalNumber);
    return new TopTenNetworksIndicatorData(indicatorData);
  }

  public async getTopTenPractitionerData(fiscalNumber: Array<string> = null): Promise<TopTenPractitionerIndicatorData> {
    const indicatorData = await this.indicatorRepository.getIndicatorDataByType("TopTenPractitioner", fiscalNumber);
    return new TopTenPractitionerIndicatorData(indicatorData);
  }
}
